import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFieldLabels } from 'services/api';
import { setFieldLabelOverrides } from 'i18n/fieldLabels';

/**
 * Etiquetas de campo sobrescritas para el grupo del usuario logueado, en su idioma.
 * Se pide tras el login y en cada cambio de idioma (los overrides son por locale).
 *
 * Además de alimentar el slice, proyecta el resultado sobre el espejo de `i18n/fieldLabels`
 * para que la función suelta `i18n()` vea los overrides sin depender del store.
 */
export const getFieldLabelsAsync: any | null = createAsyncThunk('fieldLabels/get', async () => {
  const response: any = await getFieldLabels();
  const labels = response?.data?.item?.labels ?? {};
  setFieldLabelOverrides(labels);
  return labels;
});
